(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rm-acheter-maintenant"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rm-buy-now')) {
    customElements.define('rm-buy-now', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('[data-buy-now]');
        const error = this.querySelector('.rm-buy-now__error');
        if (!button) return;
        button.addEventListener('click', async () => {
          const form = document.getElementById(this.dataset.formId);
          if (!form || !form.reportValidity()) return;
          error.hidden = true;
          button.setAttribute('aria-busy', 'true');
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          try {
            const response = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: new FormData(form)
            });
            if (!response.ok) {
              const data = await response.json().catch(() => ({}));
              throw new Error(data.description || data.message || "Impossible d'ajouter ce coffret au panier.");
            }
            window.location.href = root + 'checkout';
          } catch (e) {
            error.textContent = e.message;
            error.hidden = false;
            button.removeAttribute('aria-busy');
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rm-avis"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rm-avis')) {
    customElements.define('rm-avis', class extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('[data-track]');
        const next = this.querySelector('[data-next]');
        if (!track || !next) return;
        next.addEventListener('click', () => {
          const w = track.clientWidth;
          const atEnd = track.scrollLeft + w >= track.scrollWidth - 4;
          track.scrollTo({ left: atEnd ? 0 : Math.round(track.scrollLeft / w) * w + w, behavior: 'smooth' });
        });
      }
    });
  }

  (function () {
    if (window.rmJmCompact) return;
    window.rmJmCompact = true;
    var KEEP = 'form, textarea, input[type="email"]';
    function findBtn(root) {
      var els = root.querySelectorAll('button, a, [role="button"]');
      for (var i = 0; i < els.length; i++) {
        var t = (els[i].textContent || '').toLowerCase();
        var c = typeof els[i].className === 'string' ? els[i].className : '';
        if (t.indexOf('crire un avis') > -1 || t.indexOf('write a review') > -1 || c.indexOf('write-rev') > -1) return els[i];
      }
      return null;
    }
    function apply(root) {
      var btn = findBtn(root);
      if (!btn) return;
      root.classList.add('rm-jm-compact');
      var node = btn;
      while (node && node !== root) {
        var parent = node.parentElement;
        if (!parent) break;
        parent.style.justifyContent = 'center';
        for (var j = 0; j < parent.children.length; j++) {
          var sib = parent.children[j];
          if (sib === node || /^(STYLE|SCRIPT|LINK)$/.test(sib.tagName)) continue;
          var keep = sib.matches(KEEP) || sib.querySelector(KEEP);
          if (keep) {
            if (sib.hasAttribute('data-rm-hidden')) { sib.style.removeProperty('display'); sib.removeAttribute('data-rm-hidden'); }
          } else if (!sib.hasAttribute('data-rm-hidden')) {
            sib.style.setProperty('display', 'none', 'important');
            sib.setAttribute('data-rm-hidden', '');
          }
        }
        node = parent;
      }
    }
    function watch(root) {
      if (root.rmWatched) return;
      root.rmWatched = true;
      var raf = 0;
      function run() { raf = 0; apply(root); }
      new MutationObserver(function () { if (!raf) raf = requestAnimationFrame(run); }).observe(root, { childList: true, subtree: true });
      run();
    }
    function init() { document.querySelectorAll('#judgeme_product_reviews').forEach(watch); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rm-livraison"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rm-livraison')) {
    customElements.define('rm-livraison', class extends HTMLElement {
      connectedCallback() {
        const min = parseInt(this.dataset.min, 10);
        const max = parseInt(this.dataset.max, 10);
        const el = this.querySelector('[data-text]');
        if (!el || !min || !max) return;
        const add = (n) => {
          const d = new Date();
          d.setDate(d.getDate() + n);
          return d;
        };
        const f = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
        el.innerHTML = "Commandez aujourd'hui : livraison estimée entre le <strong>" + f.format(add(min)) + "</strong> et le <strong>" + f.format(add(max)) + "</strong>";
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
